import parse from 'html-react-parser';
import moment from 'jalali-moment';

export const getStatus = (status = null) => {
  const statuses = [
    { label: 'فعال', value: 1, color: 'danger' },
    { label: 'غیر فعال', value: 0, color: 'success' },
  ];

  return status !== null ? statuses[status] : statuses;
};

export const getAgeTypes = (ageType = null) => {
  const types = [
    { label: 'انفرادی', value: 1 },
    { label: 'تیمی', value: 2 },
    { label: 'لیگ', value: 3 },
  ];

  return ageType !== null ? types[ageType] : types;
};

export const getHasHasNot = (has = null) => {
  const types = [
    { label: 'دارد', value: 1 },
    { label: 'ندارد', value: 0 },
  ];

  return has !== null ? types[has] : types;
};

export const serverErrorHandler = (errors, setServerErrors, serverErrors) => {
  let allErrors = {};
  Object.entries(errors).forEach((el) => {
    allErrors[[el[0]]] = el[1][0];
  });
  setServerErrors(allErrors);
};

export const countOfRecourd = (index, perpage, currentPage) => {
  return perpage === undefined
    ? index
    : perpage * currentPage - perpage + index + 1;
};

export const dateToJalali = (date, format = 'YYYY/MM/DD') => {
  return moment(date ?? '1999-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss')
    .locale('fa')
    .format(format);
};

export const getApiUrl = () => process.env.REACT_APP_API_URL ?? '/';
export const getAppUrl = () =>
  process.env.REACT_APP_URL ?? 'http://localhost:3000';

export const getRelation = (field, row) => {
  const relationArray = row?.name?.split('.');
  let rel;
  if (relationArray[0] !== undefined) {
    rel = field?.[relationArray[0]];
  }
  if (relationArray[1] !== undefined) {
    rel = field?.[relationArray[0]]?.[relationArray[1]];
  }
  if (relationArray[2] !== undefined) {
    rel = field[relationArray?.[0]]?.[relationArray?.[1]]?.[relationArray?.[2]];
  }
  if (relationArray[3] !== undefined) {
    rel =
      field?.[relationArray[0]]?.[relationArray[1]]?.[relationArray[2]]?.[
        relationArray[3]
      ];
  }

  if (relationArray[4] !== undefined) {
    rel =
      field?.[relationArray[0]]?.[relationArray[1]]?.[relationArray[2]]?.[
        relationArray[3]
      ]?.[relationArray[4]];
  }

  return row?.relType === 'string' ? (
    rel
  ) : row?.relType === 'date' ? (
    dateToJalali(rel)
  ) : row?.relType === 'image' ? (
    <img src={rel} alt='' style={{ width: '60px', height: '60px' }} />
  ) : (
    rel
  );
};

export const getPhotoId = (photos, arrayReturn = true) => {
  let photoIds = photos?.map((p) => {
    let photo = JSON.parse(p.serverId);
    return photo?.data?.id;
  });

  return arrayReturn ? photoIds : photoIds[0];
};

export const getPhotoPath = (photos) => {
  let photoPath = photos?.map((p) => {
    let photo = JSON.parse(p.serverId);
    return photo?.data?.path;
  });

  return photoPath[0];
};

export const genders = () => {
  return [
    { value: 0, label: 'زن' },
    { value: 1, label: 'مرد' },
    { value: 2, label: 'هردو' },
  ];
};

export const htmlToJsx = (html) => {
  return parse(html ?? '');
};

export const isValidIranianNationalCode = (input) => {
  if (/^([0-9]+)_r/.test(input)) return true;

  if (!/^\d{10}$/.test(input)) return false;
  const check = +input[9];
  const sum =
    input
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export const getRanks = (rank) => {
  return [
    { value: 1, label: 'اول' },
    { value: 2, label: 'دوم' },
    { value: 3, label: 'سوم' },
    { value: 4, label: 'سوم مشترک' },
    { value: 5, label: 'سردم زرین' },
    { value: 6, label: 'سردم سیمین' },
    { value: 7, label: 'دیپلم افتخار' },
  ];
};
export const getRank = (rank) => {
  return rank == 1
    ? 'اول'
    : rank == 2
    ? 'دوم'
    : rank == 3
    ? 'سوم'
    : rank == 4
    ? 'سوم مشترک'
    : rank == 5
    ? 'اول'
    : rank == 6
    ? 'دوم'
    : rank == 7
    ? 'سوم'
    : '';
};
export const getMedal = (rank) => {
  return rank == 1
    ? 'طلا'
    : rank == 2
    ? 'نقره'
    : rank == 3
    ? 'برنز'
    : rank == 4
    ? 'برنز مشترک'
    : rank == 5
    ? 'سردم زرین'
    : rank == 6
    ? 'سردم سیمین'
    : rank == 7
    ? 'دیپلم افتخار'
    : '';
};

export const sportTypes = [
  { value: 0, label: 'همه' },
  { value: 1, label: 'انفرادی' },
  { value: 2, label: 'تیمی' },
  { value: 3, label: 'لیگ' },
  { value: 4, label: 'انفرادی-تیمی' },
  { value: 5, label: 'انفرادی-لیگ' },
  { value: 6, label: 'تیمی-لیگ' },
];
